import React from 'react';
import { Card } from 'react-bootstrap';
import s from './entityCard.module.css';

const viewConfig = {
  titlesOnly: { titlesAllowed: true, imagesAllowed: false, height: 30 },
  imagesOnly: { titlesAllowed: false, imagesAllowed: true, height: 155 },
  titlesAndImages: { titlesAllowed: true, imagesAllowed: true, height: 196 }
};

// TODO: use memo here ? - use bootstrap card - check ippalus max-width-height
const EntityCard = ({ title, img, viewOption = 'titlesAndImages' }) => {

  const { titlesAllowed, imagesAllowed, height } = viewConfig[viewOption];

  const Title = title ? <Card.Title className={`${s.imgTitle} text-left mt-1 mb-3 ml-2`}>{title}</Card.Title> : '';
  const Img = img ? <Card.Img variant='bottom' className={s.imgStyle} src={img} /> : '';

  // const height = (!imagesAllowed) ? 30 : 196; // adjust for only Titles
  // might need fixing for huge title names

  const border = (viewOption === 'titlesOnly') ? { border: '1px solid #DDDDFF' } : {};

  return (
    <Card className={s.cardContainer} style={{ height, ...border }}>
      {titlesAllowed && Title}
      {imagesAllowed && Img}
    </Card>
  );

};

export default EntityCard;
